import { Container, Section, Grid } from '../layout';
import { Card, Icon } from '../ui';
import { firmData } from '../../data/firmData';

export const PracticeAreasSection = () => {
  // Map practice areas to appropriate icons
  const practiceAreaIcons: Record<string, string> = {
    'Corporate Law': 'briefcase',
    'Commercial Litigation': 'scale',
    'Real Estate Law': 'globe',
    'Intellectual Property': 'lightbulb',
    'Employment Law': 'users',
    'Tax & Regulatory': 'document'
  };

  return (
    <Section id="practice-areas" padding="xl" className="bg-background-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="heading-lg text-primary-navy mb-6">
            Practice Areas
          </h2>
          <p className="body-lg text-text-medium max-w-3xl mx-auto">
            Our comprehensive legal services span across diverse practice areas, ensuring we can address 
            the full spectrum of legal challenges faced by businesses and individuals.
          </p>
        </div>

        <Grid cols={{ default: 1, md: 2, lg: 3 }} gap="lg">
          {firmData.practiceAreas.map((area, index) => (
            <Card 
              key={index} 
              variant="hover" 
              className="p-6 h-full flex flex-col group cursor-pointer"
            >
              {/* Icon and Title */}
              <div className="flex items-start mb-4">
                <div className="w-12 h-12 bg-accent-gold/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0 group-hover:bg-accent-gold/20 transition-colors duration-300">
                  <Icon 
                    name={practiceAreaIcons[area.category] as any} 
                    size="lg" 
                    className="text-accent-gold" 
                  />
                </div>
                <div className="flex-1">
                  <h3 className="heading-md text-primary-navy mb-2 group-hover:text-accent-gold transition-colors duration-300">
                    {area.category}
                  </h3>
                </div>
              </div>

              {/* Description */}
              {area.description && (
                <p className="body-base text-text-medium mb-4 flex-1">
                  {area.description}
                </p>
              )}

              {/* Services List */}
              <div className="mt-auto">
                <h4 className="font-semibold text-text-dark mb-3 text-sm uppercase tracking-wide">
                  Key Services
                </h4>
                <ul className="space-y-2">
                  {area.services.map((service, serviceIndex) => (
                    <li key={serviceIndex} className="flex items-start">
                      <Icon 
                        name="check" 
                        size="sm" 
                        className="text-accent-gold mr-2 mt-0.5 flex-shrink-0" 
                      />
                      <span className="body-sm text-text-medium">
                        {service}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Hover Effect Indicator */}
              <div className="mt-4 pt-4 border-t border-border-subtle opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="flex items-center text-accent-gold">
                  <span className="body-sm font-medium mr-2">Learn More</span>
                  <Icon name="chevronRight" size="sm" />
                </div>
              </div>
            </Card>
          ))}
        </Grid>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-background-light rounded-lg p-8">
            <h3 className="heading-md text-primary-navy mb-4">
              Need Legal Assistance?
            </h3>
            <p className="body-lg text-text-medium mb-6 max-w-2xl mx-auto">
              Our experienced legal team is ready to provide comprehensive solutions tailored to your specific needs. 
              Contact us to discuss how we can assist with your legal requirements.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn-base btn-primary"
              >
                Schedule Consultation
              </button>
              <button 
                onClick={() => {
                  const approachSection = document.getElementById('approach');
                  if (approachSection) {
                    approachSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn-base btn-secondary"
              >
                Our Approach
              </button>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};